import { AuthzGuard } from "@p0security/frontend-core/react";
import { AppPaths } from "@p0security/shared/routes/constants";
import { AgenticClientsProvider } from "components/Agentic/AgenticClientsContext";
import { Outlet, Route } from "react-router-dom";
import { QueryParamProvider } from "use-query-params";
import { ReactRouter6Adapter } from "use-query-params/adapters/react-router-6";

import { ResourcesProvider } from "../../providers/ResourcesProvider";
import { Page } from "../App/Page";
import { JIT_POLICY_ROLES } from "../App/roles";
import { BundleEditorPage } from "./BundleEditorPage";
import { PolicyEditorPage } from "./PolicyEditorPage";
import { PolicyStudioShell } from "./PolicyStudioShell";

export const PoliciesRoutes = (
  <Route element={<AuthzGuard requirement={JIT_POLICY_ROLES} />}>
    <Route
      path={AppPaths.Policies}
      element={
        <QueryParamProvider adapter={ReactRouter6Adapter}>
          <AgenticClientsProvider>
            <Outlet />
          </AgenticClientsProvider>
        </QueryParamProvider>
      }
    >
      <Route
        index
        element={
          <Page title="Policy Studio">
            <PolicyStudioShell />
          </Page>
        }
      />
      <Route element={<AuthzGuard requirement={["owner"]} />}>
        <Route
          path="new"
          element={
            <Page title="Create Policy">
              <ResourcesProvider>
                <PolicyEditorPage />
              </ResourcesProvider>
            </Page>
          }
        />
        <Route
          path="edit/:ruleId"
          element={
            <Page title="Edit Policy">
              <ResourcesProvider>
                <PolicyEditorPage />
              </ResourcesProvider>
            </Page>
          }
        />
        <Route
          path="bundles/new"
          element={
            <Page title="Create Access Bundle">
              <ResourcesProvider>
                <BundleEditorPage />
              </ResourcesProvider>
            </Page>
          }
        />
        <Route
          path="bundles/edit/:bundleId"
          element={
            <Page title="Edit Bundle">
              <ResourcesProvider>
                <BundleEditorPage />
              </ResourcesProvider>
            </Page>
          }
        />
      </Route>
    </Route>
  </Route>
);
